const $inject = ['$scope', '$filter', 'timesService'];

const lbTimeSelectCtrl = function ($scope, $filter, timesService) {
  let vm = this;

  const TIME_FORMAT = $filter('translate')('dates.TimeFormatLong');

  vm.times = timesService.getSelectOptions(TIME_FORMAT, vm.anytime);
  vm.inputName = `${vm.name}.${vm.index}`;

  vm.selectedTime = vm.time;

  $scope.$watch('vm.selectedTime', (selectedTime) => {
    vm.time = selectedTime;
  });
};

lbTimeSelectCtrl.$inject = $inject;

export default lbTimeSelectCtrl;



// WEBPACK FOOTER //
// ./src/components/lbTimeSelect/lbTimeSelectCtrl.js